<template>
  <div class="container">
    <!--<div class="container__inner">-->
      <!-- Menu -->
      <div class="menu">
        <button class="game-top" v-show="currentScreen !== 'welcome'" @click="showModal('top')"><!--GAME TOP--><img src="../assets/image/txt_gametop.png" alt="game top"></button>
        <!-- <a class="sound">SOUND<img  class="on" src="../assets/image/icn_sound_on.png" alt=""><img src="../assets/image/icn_sound_off.png" alt=""></a> -->
        <vue-audio :file="3" ref="btnClick"></vue-audio>
        <vue-audio :file="bgmFile" ref="audio" :bgm="bgm" :loop="true"></vue-audio>
      </div>

      <!-- Layout screen -->
      <template v-if="currentScreen === 'welcome'">
        <welcome></welcome>
      </template>
      <template v-else-if="_.includes(['card', 'decisionCard', 'specialCard'], currentScreen)">
        <card></card>
      </template>
      <template v-else-if="currentScreen === 'match'">
        <match></match>
      </template>
      <template v-else-if="currentScreen === 'race'">
        <race-screen></race-screen>
      </template>
      <template v-else-if="currentScreen === 'result'">
        <result></result>
      </template>
      <modal :id="key" :show.sync="isModal" :type="typeName"></modal>
    <!--</div>-->
  </div>
</template>
<script>
  import _ from 'lodash'
  import { store } from '../store/store'
  import Welcome from './Welcome'
  import Card from './Card'
  import RaceScreen from './RaceScreen'
  import Result from './Result'
  import Modal from './Modal'
  import Audio from './Audio'
  export default {
    name: 'Main',
    data () {
      return {
        msg: 'Welcome to Gene Game!',
        bgm: true,
        key: '',
        isModal: false,
        typeName: '',
        game: {
          width: 1000,
          height: 560,
          zoom: 1,
          safeWidth: 1000,
          safeHeight: 560,
          newWidth: 1000,
          newHeight: 560
        },
        scale: 1,
        ratio: 1,
        origin: {
          width: 1000,
          height: 560
        },
        browser: {
          width: window.parent.innerWidth - 40,
          height: window.parent.innerHeight - 40
        }
      }
    },
    created () {
      store.dispatch('setCurrentScreen', 'welcome')
    },
    mounted () {
      // Register an event listener when the Vue component is ready
      let self = this
      self.resizeGame2()
      window.addEventListener('resize', this.resizeGame2)
    },
    beforeDestroy () {
      // Unregister the event listener before destroying this Vue instance
      window.removeEventListener('resize', this.resizeGame2)
    },
    computed: {
      _ () {
        return _
      },
      currentScreen () {
        return store.state.currentScreen
      },
      bgmFile () {
        let bgmAudio = _.includes(_.keys(store.state.bgm), this.currentScreen) ? store.state.bgm[this.currentScreen] : 0
        this.bgm = true
        return bgmAudio
      },
      isLandscape () {
        return Math.abs(window.orientation) === 90
      }
    },
    methods: {
      showModal (key) {
        this.$refs.btnClick.play()
        this.key = key
        this.typeName = _.includes(['specialCard', 'race', 'card', 'top'], this.key) ? 'confirm' : 'alert'
        return (this.isModal = true)
      },
      resizeGame2 () {
        let appAttr = ''
        let containerAttr = ''
        let ratio = 1
        let viewport
        viewport = {
          width: window.parent.innerWidth,
          height: window.parent.innerHeight
        }
        // Determine game size
        if (this.game.height / this.game.width > viewport.height / viewport.width) {
          this.game.newHeight = viewport.height * this.game.height / this.game.safeHeight
          this.game.newWidth = this.game.newHeight * this.game.width / this.game.height
          if (this.game.safeHeight / this.game.width > viewport.height / viewport.width) {
            // A
            this.game.newHeight = viewport.height * this.game.height / this.game.safeHeight
            this.game.newWidth = this.game.newHeight * this.game.width / this.game.height
          } else {
            // B
            this.game.newWidth = viewport.width
            this.game.newHeight = this.game.newWidth * this.game.height / this.game.width
          }
        } else {
          if (this.game.height / this.game.safeWidth > viewport.height / viewport.width) {
            // C
            this.game.newHeight = viewport.height
            this.game.newWidth = this.game.newHeight * this.game.width / this.game.height
          } else {
            // D
            this.game.newWidth = viewport.width * this.game.width / this.game.safeWidth
            this.game.newHeight = this.game.newWidth * this.game.height / this.game.width
          }
        }
        this.game.newWidth = Math.min(this.game.newWidth, this.game.width)
        this.game.newHeight = Math.min(this.game.newHeight, this.game.height)
        ratio = Math.min(this.game.newWidth / this.game.width, this.game.newHeight / this.game.height)
        appAttr = 'width: ' + this.game.newWidth + 'px; '
        appAttr += 'height: ' + this.game.newHeight + 'px; '
        appAttr += 'margin: ' + Math.abs(this.game.newHeight - viewport.height) / 2 + 'px ' + Math.abs(this.game.newWidth - viewport.width) / 2 + 'px;'
        containerAttr = '-webkit-transform: scale(' + ratio + '); '
        containerAttr += '-moz-transform: scale(' + ratio + '); '
        containerAttr += '-ms-transform: scale(' + ratio + '); '
        containerAttr += '-o-transform: scale(' + ratio + '); '
        containerAttr += 'transform: scale(' + ratio + '); '
        containerAttr += '-webkit-transform-origin: left top; '
        containerAttr += '-moz-transform-origin: left top;  '
        containerAttr += '-ms-transform-origin:  left top; '
        containerAttr += '-o-transform-origin:  left top; '
        containerAttr += 'transform-origin:  left top;'
        document.getElementById('app').setAttribute('style', appAttr)
        document.getElementsByClassName('container')[0].setAttribute('style', containerAttr)
      }
    },
    components: {
      'welcome': Welcome,
      'card': Card,
      'race-screen': RaceScreen,
      'result': Result,
      'modal': Modal,
      'vue-audio': Audio
    }
  }
</script>
<style src="../assets/scss/site.scss" lang="scss"></style>



// WEBPACK FOOTER //
// Main.vue?7a8f537e